module.exports = __webpack_public_path__ + "static/img/list1.c0ef7a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/JoinUs/img/list1.jpg
// module id = im7G
// module chunks = 1